import { render } from "./Neolink.vue?vue&type=template&id=bb825c1a&scoped=true"
import script from "./Neolink.vue?vue&type=script&lang=js"
export * from "./Neolink.vue?vue&type=script&lang=js"

import "./Neolink.vue?vue&type=style&index=0&id=bb825c1a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb825c1a"]])

export default __exports__